module.exports = "<svg id=\"8f0c37a2-141f-4f72-8a09-38d930dc4ab7\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.5 50\"><title>LeftArrow</title><path d=\"M39,4.27,18.29,25,39,45.73a2.5,2.5,0,0,1-3.54,3.54L13,26.77a2.5,2.5,0,0,1,0-3.54L35.48.73A2.5,2.5,0,0,1,39,4.27Z\" transform=\"translate(-12.25 0)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/LeftArrow.svg
// module id = 518
// module chunks = 1